import { notificationVariableRegex } from '../../utils';
function createVariable(schema, text) {
  // Find the variable in the text
  const varName = text.match(notificationVariableRegex)[1];
  if (schema.nodes[varName]) {
    return schema.nodes[varName].create(null, null, []);
  } else {
    // It's an invalid variable, probably a custom field got removed
    return schema.nodes.invalidVariable.create({
      type: varName
    });
  }
}
function parseLine(schema, line) {
  const spans = [];
  // Searching for variables
  while (line.search(notificationVariableRegex) > -1) {
    const i = line.search(notificationVariableRegex);
    // Create text out of everything before the var
    if (i > 0) {
      spans.push(schema.text(line.substring(0, i)));
    }
    // Create the variable
    spans.push(createVariable(schema, line));
    // Cut off the line until the variable and continue parsing
    line = line.substring(i + line.match(notificationVariableRegex)[0].length);
  }
  if (line) {
    spans.push(schema.text(line));
  }
  return spans;
}
export function fromText(schema, text) {
  if (text) {
    const line = text.trim().replace(/\n/g, ' ');
    return schema.node('doc', null, parseLine(schema, line));
  }
  return schema.node('doc', null, []);
}